import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';

const APITest = () => {
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const [data, setData] = useState(null);

  const testAPI = async () => {
    setStatus('loading');
    setMessage('Testing API connection...');
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
     
      
      // Test health
      const healthResponse = await axios.get(`${apiUrl}/health`, { timeout: 5000 });
      
      // Test products
      const productsResponse = await axios.get(`${apiUrl}/products`, { timeout: 5000 });
     
      setStatus('success');
      setMessage(`✅ API is working! Found ${productsResponse.data.length} products`);
      setData(productsResponse.data.slice(0, 3));
    } catch (error) {
     setStatus('error');
      setMessage(`❌ API Error: ${error.message}`);
    }
  };

  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h4" sx={{ mb: 2 }}>🧪 API Test Page</Typography>
      
      <Typography variant="body1" sx={{ mb: 2 }}>
        API URL: <strong>{process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}</strong>
      </Typography>

      <Button 
        variant="contained" 
        onClick={testAPI}
        disabled={status === 'loading'}
        sx={{ mb: 2 }}
      >
        {status === 'loading' ? 'Testing...' : 'Test API'}
      </Button>

      {status === 'loading' && <CircularProgress sx={{ mt: 2 }} />}
      
      {message && (
        <Alert severity={status === 'success' ? 'success' : 'error'} sx={{ mt: 2, mb: 2 }}>
          {message}
        </Alert>
      )}

      {data && (
        <Box sx={{ mt: 2, textAlign: 'left', backgroundColor: '#f5f5f5', p: 2, borderRadius: 1 }}>
          <Typography variant="h6">Sample Products:</Typography>
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </Box>
      )}
    </Box>
  );
};

export default APITest;
